"use client";
import React, { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { CollectionWithAttribute } from "@/util/query/collection-query";
import Image from "next/image";

const RelatedCollectionCarousel = ({ collections }: { collections: any }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, dragFree: true });
    return (
        <div className="embla" ref={emblaRef}>
            <div className="embla__container">
                {collections.map((col: CollectionWithAttribute, index: number) => {
                    const image = col.imageUrl ? col.imageUrl.substring(0, col.imageUrl.lastIndexOf(".")) : "";
                    return (
                        <div key={col.handle} className="lg:basis-1/7 md:basis-1/6 sm:basis-1/5  basis-1/4">
                            <a href={`/collections/${col.handle}`}>
                                <div className="flex flex-col justify-start items-center flex-shrink-0 gap-2 lg:w-24 xl:w-32 w-20 first:ml-auto last:mr-auto">
                                    {col.imageUrl && (
                                        <picture>
                                            <source srcSet={`${image}.avif`} type="image/avif"/>
                                            <source srcSet={`${image}.webp`} type="image/webp"/>
                                            <img
                                                src={col.imageUrl}
                                                alt={col.imageAlt}
                                                width={60}
                                                height={60}
                                                loading="lazy" />
                                        </picture>
                                    )}
                                    <div className="flex flex-col">
                                        {col.attributes.shortTitle && (
                                            <div className="text-center">
                                                <p className="font-light text-c4 line-clamp-2">
                                                    {col.attributes.shortTitle}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default RelatedCollectionCarousel;
